<script setup lang="ts">
interface Props {
  search?: boolean
}
const { search } = defineProps<Props>()
const categoryStore = useCategoryStore()
const { min, max, open, checked, priceMin, priceMax, properties } = storeToRefs(categoryStore)
const { query, path } = useRoute()
onMounted(() => {
  categoryStore.getChecked({ query })
})
</script>

<template>
  <div class="p-[15px]">
    <div v-for="(filter, index) in properties" :key="filter.id">
      <div class="flex justify-between items-center border-b border-solid border-gray-400 my-[15px] pb-[10px]">
        <span class="text-18 font-medium">{{ filter.name }}</span>
        <span v-if="(index === 0 || filter.name === 'Lokalizacja') && (min || max || checked.length !== 0)" class="text-12 uppercase cursor-pointer" @click="categoryStore.load({ type: 'remove', mobile: true, path, search })">Wyczyść filtry</span>
      </div>
      <ul class="flex flex-col items-start">
        <li v-for="(data, index2) in filter.options" :key="data.id" :class="{ hidden: index2 >= 4 && !open.includes(filter.id) }" class="flex flex-row-reverse items-center gap-[15px] text-14 py-[10px]">
          <label :for="data.id" class="cursor-pointer">{{ tor(data.name) }}</label>
          <input
            :id="data.id"
            v-model="checked"
            :value="data.id"
            type="checkbox"
            @change="categoryStore.load({ type: 'properties', mobile: true, path, search })"
          >
        </li>
      </ul>
      <div v-if="filter.options.length > 4 && !open.includes(filter.id)" class="flex items-center gap-[15px] cursor-pointer py-[10px]" @click="categoryStore.openFilter(filter.id)">
        <i class="icon-arrow-menu text-12 rotate-90" />
        <span class="text-14">Pokaż wszystko ({{ filter.options.length - 4 }})</span>
      </div>
    </div>
    <div class="flex justify-between items-center border-b border-solid border-gray-400 my-[15px] pb-[10px]">
      <span class="text-18 font-medium">Cena</span>
    </div>
    <ul class="flex gap-[20px]">
      <li class="flex items-center w-full border border-solid border-gray-500 rounded-[5px]">
        <input
          v-model="min"
          type="number"
          :placeholder="priceMin.toString()"
          :min="priceMin"
          :max="priceMax"
          step="50"
          class="w-full bg-transparent text-14 px-[10px] py-[8px]"
          @change="categoryStore.load({ type: 'min-price', mobile: true, path, search })"
        >
        <span class="text-14 px-[10px]">zł</span>
      </li>
      <li class="flex items-center w-full border border-solid border-gray-500 rounded-[5px]">
        <input
          v-model="max"
          type="number"
          :placeholder="priceMax.toString()"
          :min="priceMin"
          :max="priceMax"
          step="50"
          class="w-full bg-transparent text-14 px-[10px] py-[8px]"
          @change="categoryStore.load({ type: 'max-price', mobile: true, path, search })"
        >
        <span class="text-14 px-[10px]">zł</span>
      </li>
    </ul>
  </div>
</template>
